import { useSelector } from "react-redux";
import { useNavigate, generatePath, useParams } from "react-router-dom";
import useGetClientId from "../hooks/useGetClientId";
import LoadingComponent from "./common/LoadingComponent";

import { useEffect } from "react";

export default function RoleBasedRoute({ allowedRoles, children }) {
  const { userObj } = useSelector((state) => state.user);
  
  const navigate = useNavigate();
  const { clientNameParam } = useParams();

  useEffect(() => {
    if (!userObj) {
      navigate(`/client/${encodeURIComponent(clientNameParam)}`, { replace: true })
    //   setTimeout(() => {
    //     navigate("/client", { replace: true });
    //   }, 1000);
    //   return (
    //   <div className="d-flex flex-column justify-content-center align-items-center vh-100 text-center">
    //     <h2 className="text-danger fw-bold">Logged Out</h2>

    //     <p className="mt-3 fs-5">
    //       You have been looged out of the app.
    //       <br />
    //       Please login again to continue.
    //     </p>
    //   </div>
    // );
      
    }
  }, [userObj, navigate]);
  const clientObj = useGetClientId();
  if (userObj && clientObj?.loading) {
    return <LoadingComponent loading={true} />;
  }

  if (!clientObj || clientObj?.error) {
    navigate("/client", { replace: true });
    return null;
  }
  const roleId = Number(clientObj.roleId);
  const isAllowed = allowedRoles.includes(roleId);

  if (!isAllowed) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center vh-100 text-center">
        <h2 className="text-danger fw-bold">Access Denied</h2>

        <p className="mt-3 fs-5">
          You do not have permission to access this page.
          <br />
          Please contact your administrator.
        </p>

        <button
          type="button"
          className="btn btn-primary mt-3"
          onClick={() =>
            navigate(
              generatePath("/client/:clientNameParam/property-form", {
                clientNameParam,
              }),
              { replace: true }
            )
          }
        >
          Back to Home
        </button>
      </div>
    );
  }
  return children;
}
